module.exports = __webpack_public_path__ + "assets/img/img101.9ab4ca3f.png";